export const columns = [
  {
    Header: 'כתובת',
    accessor: 'address',
  },
  {
    Header: 'גוש / חלקה',
    accessor: 'blockParcel',
  },
  {
    Header: 'סוג הנכס',
    accessor: 'propertyType',
  },
  {
    Header: 'סוג הכרעה',
    accessor: 'decisionType',
  },
  {
    Header: 'שמאי מכריע',
    accessor: 'decidingAppraiser',
  },
  {
    Header: 'מועד קובע',
    accessor: 'effectiveDate',
  },
  {
    Header: 'מועד הכרעה',
    accessor: 'decisionDate',
  },
  {
    Header: 'סוג שומה',
    accessor: 'appraisalType',
  },
  {
    Header: 'השווי שנקבע',
    accessor: 'determinedValue',
  },
  {
    Header: 'שטח',
    accessor: 'area',
  },
  {
    Header: 'השבחה',
    accessor: 'betterment',
  },
  {
    Header: 'היטל',
    accessor: 'levy',
  },
  {
    Header: 'ועדה מקומית',
    accessor: 'localCommittee',
  },
  {
    Header: 'פעולות',
    accessor: 'actions',
  },
];